var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay2Icon = function SvgPlay2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.598 12.21 7.214-4.208-7.214-4.209v8.417ZM3 2.75v10.503c0 .771.836 1.251 1.502.863l9.003-5.252a.999.999 0 0 0 0-1.725L4.502 1.888A.999.999 0 0 0 3 2.75Z",
    clipRule: "evenodd"
  })));
};
export default SvgPlay2Icon;